import debug from "debug";
import MakeControl from "./MakeControl";
const log = debug("app:mkprt");

/**
 * Class responsible for handling control-based objects in the scene.
 * @category Experience
 * @subcategory World
 */
class MakeControls {
  /**
   * Constructor for MakeControls.
   * 
   * @param {Object} experience - The main application experience object.
   */
  constructor(experience) {
    this.experience = experience;
    this.scene = experience.scene;
    this.eventHub = this.experience.eventHub;
    this.dataVault = this.experience.dataVault;
    this.ctlBoardProspects = new Set();

    this.setupEventListeners();
  }

  cleanup() {
    this.eventHub.off("control-switch"); // Remove event listener
    this.ctlBoardProspects.clear();
    this.xmdObjects = [];

    this.experience = null;
    this.scene = null;
    this.eventHub = null;
    this.dataVault = null;
}

  /**
   * Sets up event listeners for handling control-related events.
   */
  setupEventListeners() {
    this.eventHub.on("control-switch", async (event) => {
      this.eventHub.emit("deleteAuto", 10);
      log("control-switch event received:", event);
      if (event.enabled) {
        this.getBlocksWithCtlBoard();
        await this.processCtlBoardData();
        this.emitAllXmdObjects();
      }
      if (!event.enabled) {
        log("control-switch disabled");
        this.eventHub.emit("deleteAuto", 10);
      }
    });
    log("Event listeners set up for MakeControls");
  }

  /**
   * Identifies and stores all objects in the scene that contain a `ctlBoard` property.
   */
  getBlocksWithCtlBoard() {
    this.ctlBoardProspects.clear();
    this.scene.traverse((child) => {
      if (
        child.name === "XMO" &&
        child.userData &&
        child.userData.ctlBoard &&
        child.userData.ctlBoard !== ""
      ) {
        this.ctlBoardProspects.add(child);
      }
    });
    log("Boards with ctlBoard found:", Array.from(this.ctlBoardProspects));
  }

  /**
   * Processes all identified control board objects and retrieves relevant data.
   */
  async processCtlBoardData() {
    log("Starting to process ctlBoard data");
    this.xmdObjects = [];

    const promises = Array.from(this.ctlBoardProspects).map(async (child) => {
      const makeControlInstance = new MakeControl(this.experience, child);
      return makeControlInstance.fetchDataAndCreateObject();
    });
    log("promieses", promises);

    const results = await Promise.allSettled(promises);

    log("results", results);

    results.forEach((result, index) => {
      if (result.status === "fulfilled" && result.value) {
        this.xmdObjects.push(result.value); // Collect only successful results
      } else if (result.status === "rejected") {
        log(
          "Failed to process child:",
          Array.from(this.ctlBoardProspects)[index],
          "Error:",
          result.reason
        );
      }
    });

    log("Processed ctlBoard data with results:", this.xmdObjects);
  }

  /**
   * Emits an event containing all successfully processed XMD objects.
   */
  emitAllXmdObjects() {
    this.eventHub.emit("MakePartsEvent", {
      eventType: "auto",
      data: { figures: this.xmdObjects }, // Ensure you are emitting the correct collected data
    });
  }
}

export default MakeControls;
